<template>
  <div class="header">
    <div v-if="$keycloak && $keycloak.ready">
      <div v-if="$keycloak.authenticated">
        <header>
          <div class="top-bar"></div>
          <div class="welcome-bar row justify-content-md-center">
            <div class="col-md-3 logopref">
              <img :src="require('@/assets/img/logo_unicamp_pref.png')" alt="Logo Prefeitura">
            </div>
            <div class="col-md-4">
              <h1>Olá, </h1>
              <h2> {{ nome }}!</h2>
            </div>
            <div class="col-md-1">
              <a href="#" @click="$keycloak.logoutFn" class="logout-button">
                <span class="icon">
                  <i class="bi bi-door-closed closed-icon"></i>
                  <i class="bi bi-door-open open-icon"></i>
                </span>
                <span class="text">&nbsp;Sair</span>
              </a>
            </div>
          </div>
        </header>
        <div class="content" id="sistemas-vue">
          <router-view :updateSistema="updateSistemaVue"></router-view>
        </div>
      </div>
    </div>
    <div v-else>
      <h3>Usuário não autenticado</h3>
    </div>
    <div class="footer">Prefeitura - Informática</div>
  </div>

</template>

<script>
export default {
  name: "App",
  data() {
    return {
      matricula: '',
      nome: '',
      sise: '',
      token: '',
      sistema_vue: ''
    }
  },

  mounted: function () {
    this.matricula = this.$keycloak.tokenParsed.matricula
    this.sise = this.$keycloak.tokenParsed.preferred_username
    this.nome = this.$keycloak.tokenParsed.given_name
    this.$router.push({ name: 'servicos' });
  },

  methods: {
  }
}
</script>

<style src="@/assets/css/style.css" />